export const TargetConfiguration =
{
    status: true,
    message: "Target Configured Successfully"
}


